// ==============================|| OVERRIDES - PAPER ||============================== //

export default function Paper() {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        },
        outlined: {
          padding: 20
        }
      }
    }
  };
}
